import { useState, useEffect } from "react";
import { useGetAllLanguagesQuery } from "src/services/LanguageServices";

const useLanguages = () => {
  const [languages, setLanguages] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const { data, isLoading, isFetching } = useGetAllLanguagesQuery("");

  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setLanguages(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);

  return { languages, isDataLoading };
};

export default useLanguages;
